const driverShiftsTemplates = {
  table: {
    headers: {
      name: 'Nome',
      shiftStart: 'Início do Turno',
      shiftEnd: 'Fim do Turno',
      breakStart: 'Início do Intervalo',
      breakEnd: 'Fim do Intervalo',
      breakNumberStart: 'Início do Intervalo {{num}}',
      breakNumberEnd: 'Fim do Intervalo {{num}}',
    },
    actions: {
      delete: 'Remover',
    },
    toolTip: {
      noPermission: 'Você não tem permissão para executar esta ação',
    },
  },
  deleteModal: {
    header: 'Remover',
    body: 'Tem certeza de que deseja remover o(s) modelo(s) de turno?',
  },
  deleteToast: {
    body: 'Modelo de turno removido com sucesso',
  },
  form: {
    title: 'Modelo de Turno',
    templateNameHeader: 'Nome do Modelo',
    displayName: 'Nome de Exibição',
    templateInfoHeader: 'Informações do Modelo',
    shiftStart: 'Início do Turno',
    shiftEnd: 'Fim do Turno',
    breakStart: 'Início do Intervalo',
    breakEnd: 'Fim do Intervalo',
    addBreak: 'Adicionar Intervalo',
    overnightNote: 'Este é um turno noturno',
    durationError: 'A duração do turno não pode exceder 23:59',
    breakOutsideShiftError: 'Os intervalos devem estar dentro do horário do turno',
    footer: {
      create: 'Enviar',
      update: 'Salvar',
    },
  },
  create: {
    success: 'Modelo de turno criado com sucesso',
    error: 'Não foi possível criar o modelo de turno',
  },
  update: {
    success: 'Modelo de turno atualizado com sucesso',
    error: 'Não foi possível atualizar o modelo de turno',
  },
};

export default driverShiftsTemplates;
